import React, { useContext, useEffect, useRef } from "react";
import classnames from "classnames";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import BottomControlBar from "./BottomControlBar";
import BottomRightControlBar from "./BottomRightControlBar";
import { useDispatch, useSelector } from "react-redux";
import RoomContext from "../../context/RoomContext";
import * as callActions from "../../actions/callActions";
import { setUIStep } from "../../actions/meActions";

const useStyles = makeStyles((theme) =>
  createStyles({
    appBar: {
      padding: theme.spacing(0.5),
      top: "auto",
      bottom: 0,
      left: 0,
      justifyContent: "center",
      [theme.breakpoints.down("xs")]: {
        padding: theme.spacing(1),
      },
      transition: theme.transitions.create(["width"], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),

      "&.toolAreaOpen": {
        width: "75vw",
        [theme.breakpoints.down("sm")]: {
          width: "100vW",
        },
      },
      "&.whiteBoardOpen": {
        width: "50vw",
        [theme.breakpoints.down("sm")]: {
          width: "100vW",
        },
      },
    },
    logo2: {
      display: "none",
      [theme.breakpoints.up("sm")]: {
        display: "block",
      },
      "&.toolAreaOpen": {
        [theme.breakpoints.down("sm")]: {
          display: "none",
        },
      },
      "&.whiteBoardOpen": {
        [theme.breakpoints.down("sm")]: {
          display: "none",
        },
      },
      width: 70,
      maxHeight: 36,
      objectFit: "contain",
      marginLeft: 15,
    },
  })
);

const BottomBar = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { roomClient } = useContext(RoomContext);
  const { fullscreenEnabled, fullscreen, onFullscreen } = props;
  const toolAreaOpen = useSelector((state) => state.toolarea.toolAreaOpen);
  const whiteBoardOpen = useSelector(
    (state) => state.whiteboard.whiteBoardOpen
  );
  const currentCall = useSelector((state) => state.call.currentCall);
  // Root Admin marka değişince room logosu yenilensin
  useSelector((state) => state.settings.brandVersion);
  const prevCurrentCallRef = useRef();
  const roomLogoSrc =
    (window.config &&
      (window.config.logo2 ||
        window.config.logoWhite ||
        window.config.logo1)) ||
    null;

  useEffect(() => {
    const hadCall = Boolean(prevCurrentCallRef.current);
    prevCurrentCallRef.current = currentCall;

    if (hadCall && !currentCall) {
      roomClient.close(false);
      dispatch(setUIStep("MANAGEMENT_SCREEN"));
      dispatch(callActions.setDisplayMini(false));
    }
  }, [currentCall, dispatch, roomClient]);

  const handleRoomClose = () => {
    dispatch(callActions.endCall(currentCall.group.id, currentCall.roomId));
    dispatch(callActions.setCurrentCall(undefined));
  };

  return (
    <AppBar
      position="fixed"
      className={classnames(classes.appBar, {
        toolAreaOpen: toolAreaOpen,
        whiteBoardOpen: whiteBoardOpen,
      })}
      color="inherit"
    >
      <Toolbar>
        <BottomControlBar
          currentCall={currentCall}
          handleRoomClose={handleRoomClose}
        />

        <BottomRightControlBar
          fullscreenEnabled={fullscreenEnabled}
          onFullscreen={onFullscreen}
          fullscreen={fullscreen}
        />
        {roomLogoSrc && (
          <img
            alt="Logo"
            className={classnames(classes.logo2, {
              toolAreaOpen: toolAreaOpen,
              whiteBoardOpen: whiteBoardOpen,
            })}
            src={roomLogoSrc}
          />
        )}
      </Toolbar>
    </AppBar>
  );
};

BottomBar.propTypes = {
  fullscreenEnabled: PropTypes.bool,
  fullscreen: PropTypes.bool,
  onFullscreen: PropTypes.func.isRequired,
};

export default BottomBar;
